// DAG sections surfaced in switcher/nav.

export type AppId = "orchestration" | "brain";

export interface DagApp {
  id: AppId;
  name: string;
  tagline: string;
  logoSrc?: string;
  logoBg?: string;
  /** SVG path data strings rendered as a stroke icon */
  iconPaths?: string[];
  mark: string;
  accent: string;
  homePath?: string;
  externalUrl?: string;
}

// Loop icon (arrow-path) — Heroicons MIT
const LOOP_PATHS = [
  "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99",
];

// Brain icon — Lucide MIT
const BRAIN_PATHS = [
  "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z",
  "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z",
];

export const DAG_APPS: DagApp[] = [
  {
    id: "orchestration",
    name: "Orchestration",
    tagline: "control plane",
    iconPaths: LOOP_PATHS,
    mark: "↻",
    accent: "#C9A260",
    homePath: "/orchestration",
  },
  {
    id: "brain",
    name: "Brain",
    tagline: "knowledge",
    iconPaths: BRAIN_PATHS,
    mark: "◎",
    accent: "#C9A260",
    homePath: "/console",
  },
];

export function appById(id: AppId): DagApp {
  return DAG_APPS.find((a) => a.id === id) ?? DAG_APPS[0];
}

// Back-compat exports for components that still reference the old names
// DAG apps for switcher / nav
